import { useDraggable } from "@dnd-kit/core";
import { List } from "semantic-ui-react";

import { useCan } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { classNames } from "utils/common";

import type { CheckInService, Tag } from "models";

type DealerServiceItemProps = {
  tags: Tag[];
  service: CheckInService;
  onClick: (service: CheckInService) => void;
};

export const DealerServiceItem = ({ service, tags, onClick }: DealerServiceItemProps) => {
  const canEnableService = useCan(ACL_ACTIVITIES.Update, ACL_RESOURCES.CheckInService);
  const { setNodeRef, attributes, listeners, isDragging } = useDraggable({ id: service.id, disabled: !canEnableService });

  const tag = tags.find(t => t.id === service.tag_id);

  const dealerServiceItemStyle = classNames({
    "is-dragging": isDragging
  });

  return (
    <div className={`dealer-service-item-container ${dealerServiceItemStyle}`} ref={setNodeRef} {...attributes} {...listeners}>
      <List.Item className="Service" onClick={() => onClick(service)}>
        <List.Content>
          <div className="service-name-tag">
            <span>{service.name}</span>
            {tag && (
              <span className="service-tag" style={{ backgroundColor: tag.color }}>
                {tag.name}
              </span>
            )}
          </div>

          <div className="service-price">{service.price}</div>
        </List.Content>
      </List.Item>
    </div>
  );
};
